import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const paragraphHeading3: NodeRenderer = (node, children) => (
  <h3 className="text-[29px]/[38px] tablet:text-[33px]/[39px]">{children}</h3>
)
